import type { SVGProps } from 'react';

export function FishboneIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m17.1 6 .13.005q.128.014.252.056l.035.017.298.11c2.112.832 4.025 2.448 5.73 4.826l.268.383a1.07 1.07 0 0 1 0 1.207c-1.857 2.716-3.967 4.502-6.319 5.333a1.1 1.1 0 0 1-1.192-.31 8.54 8.54 0 0 1-2.054-4.555H12v3.234c0 .286-.115.56-.32.762a1.1 1.1 0 0 1-1.542 0 1.07 1.07 0 0 1-.32-.762v-3.234H7.638v1.078c0 .286-.115.56-.32.762a1.1 1.1 0 0 1-1.543 0 1.07 1.07 0 0 1-.32-.762v-1.078H4.184l-.366.35a42 42 0 0 0-1.91 1.99 1.1 1.1 0 0 1-.751.36 1.1 1.1 0 0 1-.79-.27 1.08 1.08 0 0 1-.364-.742 1.07 1.07 0 0 1 .273-.78q.647-.72 1.325-1.41l.569-.57-.57-.57a45 45 0 0 1-.67-.698l-.654-.713a1.08 1.08 0 0 1-.273-.78 1.07 1.07 0 0 1 .365-.742 1.1 1.1 0 0 1 1.54.09 43 43 0 0 0 2.257 2.33l1.29-.001V9.838a1.07 1.07 0 0 1 .32-.762 1.1 1.1 0 0 1 .772-.316 1.1 1.1 0 0 1 .771.316 1.08 1.08 0 0 1 .32.762v1.078h2.182V7.682c0-.286.114-.56.32-.763a1.097 1.097 0 0 1 1.542 0c.204.203.32.477.32.763v3.234h2.249a8.54 8.54 0 0 1 1.806-4.262l.214-.258.082-.088.115-.095.074-.051.106-.056.075-.033.15-.045.1-.018q.064-.008.128-.01m1.446 3.838c-.267 0-.525.097-.725.272s-.327.418-.358.68l-.008.137c0 .274.107.539.298.739a1.096 1.096 0 0 0 1.876-.613l.008-.137c0-.286-.115-.56-.32-.762a1.1 1.1 0 0 0-.771-.316" />
    </svg>
  );
}
